<section class="mb-4">
  <nz-search-input
    [searchValue]="searchValue"
    (onSearchValueChange)="onSearch($event)"
    placeholder="Търсене по вид или обява...">
  </nz-search-input>
</section>
<section class="mb-4">
  <nz-search-result
    [totalResults]="this.totalResults"
    [sortOptions]="sortOptions"
    [selectedSortOption]="selectedSortOption"
    (onSortOptionChange)="onSort($event)">
  </nz-search-result>
</section>
@if (!loading) {
  @if (notifications.length === 0) {
    <h4 class="my-5 text-muted">
      Няма намерени известия
    </h4>
  }
  <section>
    <ul class="list-unstyled" nzRestoreScrollPosition>
      @for (notification of notifications; track notification.userNotificationId) {
        <li class="my-3 d-flex border shadow bg-white rounded-3">

          @if (!!notification.relatedUserId) {
            <a class="profile-card-image"
               [routerLink]="[appRoutes.root, appRoutes.profile, notification.relatedUserId]">
              <nz-image [imageUrl]="!!notification.relatedUserProfileImageId
              ?  environment.apiImageUserProfileUrl + '/' + notification.relatedUserId + '/' + notification.relatedUserProfileImageId
              : environment.apiImageDefaultUserProfileUrl"/>
            </a>
          } @else {
            <a class="profile-card-image"
               [routerLink]="[appRoutes.root, appRoutes.ad, notification.adId]">
              <nz-image [imageUrl]="environment.apiImageAdUrl + '/main/' + notification.adId"/>
            </a>
          }
          <div class="profile-card-body d-flex flex-column justify-content-between">
            <div class="d-flex justify-content-between">
              <div class="text-truncate">
                <a class="px-2 pb-0 btn btn-link d-block text-truncate text-decoration-none text-start"
                   [class.fw-bold]="!notification.isRead"
                   [routerLink]="!!notification.adId ?
                      [appRoutes.root, appRoutes.ad, notification.adId] :
                      [appRoutes.root, appRoutes.profile, notification.relatedUserId]">
                  {{ notification.notificationTypeName }}
                </a>
                <div class="px-2 text-muted text-truncate">
                  {{ !!notification.adId ? notification.adTitle : notification.relatedUsername }}
                </div>
              </div>
              <div class="dropdown">
                <button type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        class="btn btn-light text-muted dropdown-button">
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                </button>
                <ul class="dropdown-menu dropdown-menu-end rounded-end-0 shadow">
                  <li>
                    <a class="dropdown-item"
                       [routerLink]="!!notification.adId ?
                          [appRoutes.root, appRoutes.ad, notification.adId] :
                          [appRoutes.root, appRoutes.profile, notification.relatedUserId]">
                      <i class="dropdown-item-icon text-muted fa-solid fa-eye" aria-hidden="true"></i>
                      {{ !!notification.adId ? 'Преглед на обявата' : 'Преглед на профила' }}
                    </a>
                  </li>
                  <hr class="dropdown-divider">
                  <li>
                    <button class="dropdown-item text-danger"
                            (click)="deleteProfileNotification(notification.userNotificationId)">
                      <i class="dropdown-item-icon fa-solid fa-trash-can" aria-hidden="true"></i>
                      Изтриване на известието
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            <small class="p-2 pt-0 text-end text-muted">
              {{ notification.dateTime | date: 'dd:MM:yyyy г., HH:mm ч.' }}
            </small>
          </div>
        </li>
      }
    </ul>
  </section>
} @else {
  <section class="my-5">
    <div class="text-center">
      <h1>
        <i class="text-dark fa-solid fa-spinner fa-spin"></i>
      </h1>
      <h5 class="text-muted">Зареждане...</h5>
    </div>
  </section>
}
@if (this.totalResults > defaultPageLimit) {
  <section class="py-4">
    <nz-pagination
      [totalResults]="totalResults"
      [selectedPage]="selectedPage"
      [selectedPageLimitOptionId]="selectedPageLimitOptionId"/>
  </section>
}
